import {
    Box,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
    TextField,
  } from "@mui/material";
  import UTextField from "../../components/mui/UTextField";
  import { useRef } from "react";
  import { useParams } from "react-router-dom";
  import { useEffect } from "react";
  import { useState } from "react";
  import { getAPI } from "../../services/commonService";
  
  // API
  import { fni18n } from "../../services/commonService";
  
  import { makeStyles } from "@material-ui/core/styles";
  import { theme } from '../../assets/themes';
  import UTable from "../../components/mui/UTable";
  import { API } from "../../config";
  
  const imageColumns = [
    { 
      field: 'id',
      headerName: 'No',
      width: 90,
      hide: true,
    },
    {
      field: 'exitImg',
      headerName: '방출구 이미지',
      align: "center",
      headerAlign: "center",
      renderCell: (params) =>
      (
      <>테스트</>
      ),
    },
    {
      field: 'usrImg',
      headerName: '사용자 이미지',
      width: 80,
      headerAlign: "center",
      align: "center",
    },
    {
      field: 'jnl',
      headerName: '거래명세표',
      width: 80,
      headerAlign: "center",
      align: "center",
    },
  ];
  
  
  const dataColumns = [
    { 
      field: 'id',
      headerName: 'No',
      width: 90,
      hide: true,
    },
    //Bill
    {
      field: 'billCnt',
      headerName: '지폐',
      width: 100,
      headerAlign: 'center',
      align: 'center',
      colSpan: [
          {
              parentField: 'billCnt',
              field: 'bill100Cnt',
              headerName: '$100',
              width: 50,
              editable: false,
              align: "center",
              headerAlign: "center"
          },    
          {
              parentField: 'billCnt',
              field: 'bill50Cnt',
              headerName: '$50',
              width: 50,
              editable: false,
              align: "center",
              headerAlign: "center"
          },    
          {
              parentField: 'billCnt',
              field: 'bill20Cnt',
              headerName: '$20',
              width: 50,
              editable: false,
              align: "center",
              headerAlign: "center"
          },    
          {
              parentField: 'billCnt',
              field: 'bill10Cnt',
              headerName: '$10',
              width: 50,
              editable: false,
              align: "center",
              headerAlign: "center"
          },    
          {
              parentField: 'billCnt',
              field: 'bill5Cnt',
              headerName: '$5',
              width: 50,
              editable: false,
              align: "center",
              headerAlign: "center"
          },    
          {
              parentField: 'billCnt',
              field: 'bill1Cnt',
              headerName: '$1',
              width: 50,
              editable: false,
              align: "center",
              headerAlign: "center"
          },
          {   
              parentField: 'billCnt',
              field: 'billTotal',
              headerName: '합계',
              width: 50,
              editable: false,
              align: "center",
              headerAlign: "center",
              valueFormatter: (params)=>{
                if (params.value == null) {
                    return '0';
                }
                return "$"+Number(params.value).toLocaleString('en-US');
            }
          },
      ],
  },//Coin_in
  {
      field: 'CoinInCnt',
      headerName: '동전',
      width: 50,
      headerAlign: 'center',
      align: 'center',
      colSpan: [
           {
               parentField: 'CoinInCnt',
               field: 'coin25Cnt',
               headerName: '25₵',
               width: 50,
               editable: false,
               align: "center",
               headerAlign: "center"
           },    
           {
               parentField: 'CoinInCnt',
               field: 'coin10Cnt',
               headerName: '10₵',
               width: 50,
               editable: false,
               align: "center",
               headerAlign: "center"
           },    
           {
               parentField: 'CoinInCnt',
               field: 'coin5Cnt',
               headerName: '5₵',
               width: 50,
               editable: false,
               align: "center",
               headerAlign: "center"
           },    
           {
               parentField: 'CoinInCnt',
               field: 'coin1Cnt',
               headerName: '1₵',
               width: 50,
               editable: false,
               align: "center",
               headerAlign: "center"
           },    
           {
              parentField: 'CoinInCnt',
              field: 'coinTotal',
              headerName: '합계',
              width: 50,
              editable: false,
              align: "center",
              headerAlign: "center",
              valueFormatter: (params)=>{
                if (params.value == null) {
                    return '0';
                }
                return Number(params.value).toLocaleString('en-US')+"¢";
              }
            },
       ]
   },
   {
    field: 'TotalAmount', //**TODO 추가 컬럼
    headerName: '총합계',
    width: 100,
    editable: false,
    align: "center",
    headerAlign: "center",
    valueFormatter: (params)=>{
      if (params.value == null) {
          return '0';
      }
      return Number(params.value).toLocaleString('en-US')+"¢";
    },
  },
  ];
  //export default function HistPopUpPage({ history }) {
  export default function CloseMachinePopUpPage(props) {
    const data = props.data;
    const printRef = useRef();
    const [detailInfo, setDetailInfo] = useState({
      storeCd: "",
      machId: "",
      trnsctDt: "",
      trnsctSeq: "",
      jrnlMsg: "",
      machIp: "",
      machPort: "",
      trnsctKndCd: "",
      trnsctKndCdnm: "",
      userId: "",
      userNm: "",
      grpCd: "",
      grpNm: "",
    });
  
    const [itemData, setItemData] = useState([
      {
        id: "0",
        img: "1",
        title: "image",
        exitImg: "",
        usrImg: "ㄱㄱ",
        jrnlMsg: "ㄴㄴ",
      },
    ]);
  
    const useStyles = makeStyles({
      table: {
          "& .MuiTableCell-root": {
              border: "1px solid #EAEAEA",
              borderTop: "1px solid #EAEAEA",
          }
      },
      header:{
          fontWeight:"bold",
          "& .MuiTableCell-root": {
            // width:195,
          }
      },
      cellTitle:{
          backgroundColor:theme.custom.appbarBgColor,            
      },
      cell:{
          padding:5
      }
  });
  const classes = useStyles();
    //화면 로드 시
    useEffect(() => {
      const getLoadData = async () => {
        try {
          await loadJournal(data.tid);
        } catch (e) {
          console.log(e.message);
        }
      };
      getLoadData();
    }, []);
  
    const loadJournal = async (tid) => {
      try{
        await getAPI(API.TRANS.HIST_JRNL, { tid: tid })
        .then((res) => {
          // console.log("loadJournal:");
          // console.log(res.data.result);        
          if (res.data.result.length > 0) {
            setDetailInfo(res.data.result[0]);
            loadImages(
              res.data.result[0].machIp,
              res.data.result[0].machPort,
              res.data.result[0].trnsctDt,
              res.data.result[0].trnsctSeq
            );
          } else {
          }
        })
        .catch((error) => {
          console.log(error.message);
        });
      }catch(error){
  
      }
    };
  
    const loadImages = async (ip, port, dt, no) => {
  
      const token = Math.floor(Math.random() * 1000000) + 1;
      const strUrl = `https://${ip}:${port}/svc/if/setSTILLToken?token=${token}`;
      try {
        await getAPI(strUrl).then((res) => {
          if (res && res.status === 200) {
            const date = dt.substring(0, 8);
            // const imgUrl = `http://${ip}:${port}/svc/if/still/${date}/${no}?ip=${process.env.REACT_APP_IP}&token=${token}`;
            const imgUrl = `https://${ip}:${port}/svc/if/still/${date}/${no}?ip=${window.location.host}&token=${token}`;
            getAPI(imgUrl).then((res2) => {
              if (res2 && res2.status === 200 && res2.data.length > 0) {
                //const _inputData = res2.
                const _inputData = res2.data.map((m) =>
                  m.pos === "CAM1"
                    ? {
                        img: m.imgUri,
                        title: "방출구이미지",
                      }
                    : {
                        img: m.imgUri,
                        title: "사용자거래이미지",
                      }
                );
                setItemData(_inputData);
              }
            });
          } else {
          }
        });
      } catch (e) {
        console.log(e.message);
      }
    };
  
    const printFunc = () => {
      let printContent = printRef.current.innerHTML;
      let originalContent = document.body.innerHTML;
      document.body.innerHTML = printContent;
  
      window.print();
      document.body.innerHTML = originalContent;
      //history.go(0);
    };
  
    return (
      <div className="main-container" style={{ width:"96%",marginLeft:"20px", marginRight:"20px"}}>
              <Box sx={{pt:"20px",pb:"40px"}}>
                <Table>
                  <TableRow sx={{backgroundColor: '#F6F6F6',}}>
                    <TableCell sx={{border: "1px solid #EAEAEA",}} align="center">{fni18n('저널')}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{border: "1px solid #EAEAEA", }} align="center">
                      <TextField
                        aria-readonly
                        sx={{ width: "90%" }}
                        id="filled-multiline-static"
                        multiline
                        rows={22}
                        variant="filled"
                        size="small"
                        inputProps={{ style: { fontSize: 14 } }}
                        value={data.jnul.replaceAll(/(\\n)/g, "\n")}/>
                    </TableCell>
                  </TableRow>
                </Table>
              </Box>
      </div>
    );
  }
  